import React, { useEffect, useState } from "react";
import { Stepper, Step, StepLabel } from "@mui/material";
import { useAppSelector } from '../../Store/hooks';
import { SelectStatus, SelectShipment } from '../../Store/Selectors';
import { stageList } from "../../Models/Status";
import { CustomStepComponent } from "./CustomStepComponent/CustomStepComponent";
import { CustomStepConnector } from "./CustomStepConnector/CustomStepConnector";
import "./ProgressBar.component.scss";

export const ProgressBar: React.FC = () => {
  const [isVertical, setVertical] = useState<boolean>(false);
  const statusState = useAppSelector(SelectStatus);
  const isLoading = useAppSelector(SelectShipment).loading;
  const stagesOrder = statusState.stages ?? [];
  const stageString = statusState.currentStatus?.stage;

  const stage =
    statusState.currentStatus?.stage === stageList.Unzustellbar
      ? 5
      : statusState.stages.indexOf(
        stageString ?? stageList.Sortierzentrum
      ) ?? 0;

  const displayClass =
    !isLoading && stageString?.length && !statusState?.error?.status
      ? "progress-bar-display"
      : "progress-bar-hidden";

  useEffect(() => {
    const isSmall = window.matchMedia("(min-width: 520px)")
    setVertical(!isSmall.matches)

    isSmall.addEventListener('change', () => setVertical(!isSmall.matches))

    return () => isSmall.removeEventListener('change', () => setVertical(!isSmall.matches));

  }, []);

  return (
    <div className={`${displayClass} my-5`}>
      <Stepper
        alternativeLabel={!isVertical}
        orientation={isVertical ? 'vertical' : 'horizontal'}
        activeStep={stage}
        connector={<CustomStepConnector visible={true} />
        }
      >
        {stagesOrder.map((label, index) => (
          <Step key={label}>
            <StepLabel key={index} StepIconComponent={CustomStepComponent} error={label === 'Unzustellbar'} >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};
